/* This is STATIC version of sore model */
export const state = () => ({
  titles: {
    news: {
      loaded: true,
      title: 'Новости',
      text: 'Описание раздела новостей.',
      image: '',
    },
    cases: {
      loaded: true,
      title: 'Мы предлагаем креативные решения',
      text: 'Какие бы нестандартные задачи ни стояли, Russ Outdoor предложит индивидуальный подход и по-настоящему эффективное решение.',
      image: 'images/index/cases-img.svg',
    },
    world: {
      loaded: true,
      title: 'Мы опираемся на&nbsp;мировой опыт',
      text: 'Стратегическим партнером Russ Outdoor является JCDecaux - признанный мировой лидер наружной рекламы. Доступ к экспертизе партнеров позволяет предоставлять продукты и сервис европейского уровня, определяя лидирующее положение Russ Outdoor в отрасли.',
      image: 'images/index/world-img.svg',
    },
    expert: {
      loaded: true,
      title: 'Мы — эксперты визуальных коммуникаций',
      text: 'Russ Outdoor активно внедряет в свой бизнес современные технологи и уже сегодня предоставляет рекламодателям эксклюзивные возможности размещения с использованием real-time таргетинга.',
      image: '',
    },
  },
  /* List of elements */
  entities: {
    expert: {
      loaded: false,
      items: [
        {
          id: "1549",
          title: "Этот элемент - для текстов в раздел &quot;Мы — эксперты...&quot;",
          image: "http://new.russoutdoor.ru/i/pic.jpg",
          link: "http://new.russoutdoor.ru/expert/?id=1549&sid=155",
          text: "Конструкции компании представлены в 38-ми российских городах. Инвентарная линейка оператора включает все основные форматы наружной рекламы, в том числе высокотехнологичные digital экраны, по техническим характеристикам не имеющие аналогов в России.",
        },
      ],
    },
    cases: {
      loaded: true,
      items: [
        {
          id: '1',
          title: 'Очень длинное название проекта, еле умещающееся в три строки',
          text: 'Краткое описание проекта, цель, задача, решение, охват, количество просмотров, эффект рекламной кампании (или другая информация). ',
          image: '/images/_tmp/project.jpg',
          url: '/creative/1',
        },
        {
          id: '2',
          title: 'Короткое название',
          text: 'Какие бы нестандартные задачи ни стояли, Russ Outdoor предложит индивидуальный подход и по-настоящему эффективное решение.',
          image: '/images/_tmp/3.jpg',
          url: '/creative/2',
        },
        {
          id: '3',
          title: 'Digital ситиборд с трансляцией в режиме 360o',
          text: 'Первая в России конструкция, имеющая экраны не только на двух основных сторонах, но и на боковых. Таким образом ситиборд объединяет в себе четыре экрана в один с разрешением 1360 x 440 пикселей, что открывает принципиально новые возможности для рекламодателей.',
          image: '/images/_tmp/product.jpg',
          url: '/creative/3',
        },
        {
          id: '4',
          title: 'Проект с дополненной реальностью на сити-формате для ТНТ',
          text: 'В мае 2017 г. в Словении была установлена автобусная остановка с дополненной реальностью, демонстрирующая невероятные сцены из жизни дикой природы на фоне урбанистического пейзажа. Кампания под названием «Начало чего-то удивительного» предлагала перенестись в подводное царство и исследовать водный мир в ожидании автобуса.',
          image: '/images/_tmp/2.jpg',
          url: '/creative/4',
        },
      ],
    },
    world: {
      loaded: true,
      items: [
        {
          id: '1',
          title: 'Очень длинное название проекта',
          text: 'Краткое описание проекта, цель, задача, решение, охват, количество просмотров, эффект рекламной кампании (или другая информация). ',
          image: '/images/_tmp/project.jpg'
        },
        {
          id: '2',
          title: 'Короткое название',
          text: 'Какие бы нестандартные задачи ни стояли, Russ Outdoor предложит индивидуальный подход и по-настоящему эффективное решение.',
          image: '/images/_tmp/3.jpg'
        },
        {
          id: '3',
          title: 'Короткое название 2',
          text: 'Какие бы нестандартные задачи ни стояли, Russ Outdoor предложит индивидуальный подход и по-настоящему эффективное решение.',
          image: '/images/_tmp/3.jpg'
        },
        {
          id: '4',
          title: 'Короткое название 3',
          text: 'Какие бы нестандартные задачи ни стояли, Russ Outdoor предложит индивидуальный подход и по-настоящему эффективное решение.',
          image: '/images/_tmp/3.jpg'
        },
      ],
    },
    news: {
      loaded: true,
      items: [
        {
          id: '1',
          date: '24.11.2017',
          title: 'Новый управляющий директор филиала Russ Outdoor в Санкт-Петербурге',
          text: 'Орлов будет отвечать за взаимодействие с органами государственной власти, включая продвижение и защиту интересов Компании, а также реализацию стратегических инициатив Компании на территории г. Санкт-Петербурга. Оператору наружной рекламы максимально важно поддерживать контакт с государственными структурами, в том числе, в рамках диалог власти и общества. Орлов будет отвечать за реализацию ...',
          image: '/images/_tmp/3.jpg',
          url: '#',
        },
        {
          id: '2',
          date: '12.11.2017',
          title: 'Russ Outdoor на Best Cases Conference',
          text: 'Краткое описание проекта, цель, задача, решение, охват, количество просмотров, эффект рекламной кампании (или другая информация). Краткое описание проекта, цель, задача, решение, охват, количество просмотров, эффект рекламной кампании. Далее инф...',
          image: '/images/_tmp/3.jpg',
          url: '#',
        },
        {
          id: '3',
          date: '01.11.2017',
          title: 'Новый управляющий директор филиала Russ Outdoor в Санкт-Петербурге',
          text: 'Орлов будет отвечать за взаимодействие с органами государственной власти, включая продвижение и защиту интересов Компании, а также реализацию стратегических инициатив Компании на территории г. Санкт-Петербурга. Оператору наружной рекламы максимально важно поддерживать контакт с государственными структурами, в том числе, в рамках диалог власти и общества. Орлов будет отвечать за реализацию ...',
          image: '/images/_tmp/3.jpg',
          url: '#',
        },
        {
          id: '4',
          date: '21.10.2017',
          title: 'Новый управляющий директор филиала Russ Outdoor в Санкт-Петербурге',
          text: 'Орлов будет отвечать за взаимодействие с органами государственной власти, включая продвижение и защиту интересов Компании, а также реализацию стратегических инициатив Компании на территории г. Санкт-Петербурга. Оператору наружной рекламы максимально важно поддерживать контакт с государственными структурами, в том числе, в рамках диалог власти и общества. Орлов будет отвечать за реализацию ...',
          image: '/images/_tmp/3.jpg',
          url: '#',
        },
        {
          id: '5',
          date: '16.10.2017',
          title: 'Новый управляющий директор филиала Russ Outdoor в Санкт-Петербурге',
          text: 'Орлов будет отвечать за взаимодействие с органами государственной власти, включая продвижение и защиту интересов Компании, а также реализацию стратегических инициатив Компании на территории г. Санкт-Петербурга. Оператору наружной рекламы максимально важно поддерживать контакт с государственными структурами, в том числе, в рамках диалог власти и общества. Орлов будет отвечать за реализацию ...',
          image: '/images/_tmp/3.jpg',
          url: '#',
        },
      ],
    },
    products_outd: {
      loaded: true, items: [
        {
          id: "1",
          title: "Digital Билборд",
          image: '/images/_tmp/product.jpg',
          text: "<p>Цифровой экран</p><p>Магистральные конструкции</p>",
          link: '/products/outdoor/1',
        },
        {
          id: "2",
          title: "Digital Суперсайт",
          image: '/images/_tmp/2.jpg',
          text: "<p>Магистральные конструкции</p>",
          link: '/products/indoor/1',
        },
        {
          id: "3",
          title: "Билборд",
          image: '/images/_tmp/2.jpg',
          text: "<p>Магистральные конструкции</p>",
          link: '/products/special/1',
        },
        {
          id: "4",
          title: "Ситиборд",
          image: '/images/_tmp/2.jpg',
          text: "<p>Цифровой экран</p><p>Уличная мебель</p>",
          link: '/products/outdoor/1',
        },
        {
          id: "5",
          title: "Суперсайт",
          image: '/images/_tmp/product.jpg',
          text: "<p>Магистральные конструкции</p>",
          link: '/products/city/1',
        },
      ],
    },
  },
  /* Single element */
  single: {
    news: {
      date: '04.11.2017',
      title: "Russ Outdoor устанавливает остановки по проекту известного архитектора Нормана Фостера в Санкт-Петербурге",
      image: "http://new.russoutdoor.ru/upload/iblock/18c/2.jpg",
      text: '<blockquote>Оператор наружной рекламы Russ Outdoor в рамках договора, заключенного по итогам торгов, принял решение ' +
        'по собственной инициативе обновить 50 остановочных павильонов в городе Санкт-Петербурге, ' +
        'на Невском и Московском проспектах.</blockquote>' +
        '<p>Проект остановочного павильона принадлежит всемирно известному британскому архитектору, ' +
        'лауреату Императорской и Притцкеровской премий, Норману Фостеру. ' +
        'Аналогичные конструкции успешно функционируют в нескольких мировых столицах с различными ' +
        'климатическими условиями: Лондоне, Париже, Сеуле, Москве. </p>' +
        '<figure>' +
        '  <p><img src="/images/_tmp/2.jpg" alt="Картинка"></p>' +
        '  <figcaption>' +
        '   <p>Картинка с текстом оформляется в стандартный HTML5-тег fugure, а подпись - в тег figcaption. Подпись становится слева от картинки. Картинку нужно обернуть в абзац, чтобы у неё появились красивые поля.</p>' +
        '   <p>Оберните текст в абзац. Шифрование происходит автоматически, что обеспечивает полную анонимность. Для наглядной демонстрации эффективности технологии компания Russ Outdoor пригласила крупнейшие рекламные агентства.</p></figcaption>' +
        '</figure>' +
        '<h1>Заголовок первого уровня</h1>' +
        '<p>Для Санкт-Петербурга архитектурное бюро Фостера разработало проекты реконструкции острова ' +
        'Новая Голландия и торгового комплекса Апраксин двор.</p>' +
        '<h2>Заголовок второго уровня, чуть поменьше размером</h2>' +
        '<p>Остановочные павильоны, изготавливаемые по лицензии в РФ, выполняют основные социальные ' +
        'функции: защищают от непогоды и предоставляют место для отдыха. ' +
        'В темное время суток внутреннее и <b>внешнее пространство</b> остановочного павильона освещает ' +
        'рекламная конструкция. Руководствуясь принципами формирования комфортной городской среды ' +
        'в преддверии социально значимого мероприятия в городе – <a href="#">Чемпионата Мира по футболу FIFA</a> – ' +
        'и в рамках городской программы Russ Outdoor дополнительно оснащает остановочные пункты ' +
        '«умными» функциями.</p>' +
        '<h3>Третий уровень ещё мельче, но всё же заметен и по-прежнему красив</h3>' +
        '<p>Павильоны оборудуются такими же табло с информацией о приходе общественного транспорта, ' +
        'как и в других общественных местах города. Остановки интегрируются с городской сетью Wi-Fi. ' +
        'Интернет предоставляет оператор связи, привлеченный городом для раздачи сигнала на стадионе ' +
        'во время проведения ЧМ 2018 и в общественном транспорте.</p>' +
        '<blockquote>' +
        ' <header>' +
        '   <h3>Фамилия Человека в H3</h3>' +
        '   <p><small>Должность идет в абзаце внутри тега small</small></p>' +
        ' </header>' +
        ' <p>Цитата сразу после заголовка в обычном теге абзаца. Единственное дополнение: ' +
        'заголовок должен идти в стандартном HTML5-теге header</p>' +
        '</blockquote>' +
        '<p>Павильоны разработаны таким образом, что в конструкцию может быть интегрировано ' +
        'дополнительное оборудование для наращивания функционала. ' +
        'Масштабирование сделает комплексы максимально комфортными и полезными для горожан. ' +
        'Мы готовы устанавливать также технологичные дисплеи, однако инфраструктура города ' +
        'не позволяет круглосуточно транслировать digital-формат. </p>' +
        '<p>Будем дальше обсуждать с городскими властями увеличение количества функциональных ' +
        'возможностей остановочных пунктов, например, в случае круглосуточной подачи ' +
        'электроэнергии, – комментирует проект Жан-Эммануэль де Витт, управляющий ' +
        'директор Russ Outdoor. – Мы гордимся тем, что именно нам выпала возможность ' +
        'украсить город в преддверии такого масштабного события, как Чемпионат Мира ' +
        'по футболу FIFA 2018. </p>' +
        '<h4>Заголовок четвертого уровня выделяет значимый текст, который можно использовать для аннотации к статье, краткого анонса, выделения общей мысли, например, Russ Outdoor – крупнейший оператор наружной рекламы и уличной мебели \n' +
        'в России. Центральный офис находится в Москве, компания имеет разветвленную федеральную сеть филиалов. С 1995 года оператор, реализуя полный цикл создания и поддержки продукции, предлагает заказчикам комплексные решения для эффективных рекламных кампаний.</h4>' +
        '<p>Сейчас отличное время, чтобы начать этот проект и ' +
        'продемонстрировать гостям и жителям, что Санкт-Петербург – действительно ' +
        'культурная столица с комфортными условиями проживания».</p>' +
        '<ol>' +
        '<li>Нумерованные списки сразу становятся вот такими красивыми.</li>' +
        '<li>Сеть цифровых и статичных щитов классического формата 3*6 на оживленных магистралях и улицах Москвы, ' +
        'Санкт-Петербурга и регионов.</li>' +
        '<li>Сеть сити-форматов и уличной мебели (остановки, пиллары, указатели), охватывающая центральную часть города.</li>' +
        '<li>Indoor: реклама в торговых центрах и магазинах.</li>' +
        '<li>Эксклюзивные рекламные поверхности: крышные конструкции, брандмауэры, медиафасады, формат «Нестандарт».</li>' +
        '<li>Рекламные конструкции в аэропорту Пулково: крупноформатные рекламоносители, цифровые видеостены, ' +
        'стойки для брендирования, сети экранов большого формата, нестандартные поверхности для креативного использования.</li>' +
        '</ol>' +
        '<div class="columns"><p>Чтобы сделать блок многоколоночным (двух-колоночным), достаточно создать блок div, section, ' +
        'или любой другой, и добавить ему класс columns. На маленьких экранах блок становится одноколоночным. Могу привязать к любому другому блоку или любому другому классу. Такой блок будет иметь две колонки.</p> ' +
        '<p>Первые результаты теста демонстрируют высокую эффективность технологии Synaps для демонстрации сообщений для целевой аудитории в реальном времени. ' +
        'Распознавание автомобилей происходит на расстоянии до 250 м от конструкции, вне зависимости от того, в каком ряду и в какое время суток они двигаются. ' +
        'С 1 ноября технология Synaps доступна на 12-ти цифровых суперсайтах Russ Outdoor и уже сейчас рекламные агентства и рекламодатели могут получить полный доступ ' +
        'к этой уникальной пользовательской платформе.</p>' +
        '<p>В тексте также может быть картинка. И не только в многоколоночном. Просто вставляйте картинку как стандартный img, можно обернуть в абзац, это не принципиально. Но две кратинки подряд лучше обернуть в абзацы, чтоб не слиплось.</p>' +
        '<p><img src="/images/_tmp/3.jpg" alt="Картинка"></p>' +
        '<p>А это текст после картинки. Видите, как он красиво следует после неё? Ничего не прилипает, потому что текст завернут в красивые абзацы p, а не br.</p>' +
        '</div>' +
        '<p>«Результат тестовой кампании технологии Synaps приятно удивил. Одно дело - обсуждать вопрос в теории, ' +
        'предлагать и выслушивать аргументы за и против, высказывать сомнения. ' +
        'Другое дело - поехать и убедиться, что технология работает и работает, как надо. ' +
        'Я думал меня уже нельзя ничем удивить».</p>' +
        '<blockquote class="pictured">' +
        ' <figure>' +
        '  <p><img src="/images/_tmp/2.jpg" alt="Картинка"></p>' +
        '  <figcaption>' +
        '     <header>' +
        '       <h3>Фамилия Человека в H3</h3>' +
        '       <p><small>Должность идет в абзаце внутри тега small</small></p>' +
        '     </header>' +
        '     <p>Так как это цитата с картинкой, она состоит из блока цитаты blockquote (с классом pictured) и внутри него блока figure, аналогичного выше. Внутреннее устройство аналогично обычной цитате с авторством.</p>' +
        '   </figcaption>' +
        ' </figure>' +
        '</blockquote>'
      ,
      video_file: "http://new.russoutdoor.ru/upload/iblock/17b/c-hr.mp4",
      video_link: "https://youtu.be/QcpZFRtKMok",
      slides: [
        {
          id: '1',
          image: '/images/_tmp/project.jpg'
        },
        {
          id: '2',
          image: '/images/_tmp/3.jpg'
        },
      ],
    },
    cases: {
      title: "Digital ситиборд с трансляцией в режиме 360o",
      image: "http://new.russoutdoor.ru/upload/iblock/18c/2.jpg",
      text: '<p>Первая в России конструкция, имеющая экраны не только на двух основных сторонах, но и на боковых. ' +
        'Таким образом ситиборд объединяет в себе четыре экрана в один с разрешением 1360 x 440 пикселей, что открывает ' +
        'принципиально новые возможности для рекламодателей. На данной конструкции впервые применено решение, позволяющее ' +
        'в одном цикле воспроизводить как разные ролики на сторонах А и Б, так и один общий ролик на всей поверхности ' +
        'в режиме 360 градусов. Шаг установки диодов по высоте и ширине экрана равен 6,1 мм, а угол обзора по вертикали ' +
        'и горизонтали составляет до 110 градусов.</p>' +
        '<h2>Данная конструкция не имеет аналогов в России</h2> ' +
        '<p>Идея создания принадлежит специалистам компании Russ Outdoor, которые подготовили техническое задание.' +
        'Разработчиком и изготовителем экранной части в соответствии с техническим заданием и под контролем ' +
        'специалистов Russ Outdoor выступила компания «Ната - Инфо».</p>',
      video_link:
        "https://youtu.be/QcpZFRtKMok",
    },
    world: {
      title: "Digital ситиборд с трансляцией в режиме 360o",
      image: "http://new.russoutdoor.ru/upload/iblock/18c/2.jpg",
      text: '<p>Первая в России конструкция, имеющая экраны не только на двух основных сторонах, но и на боковых. ' +
        'Таким образом ситиборд объединяет в себе четыре экрана в один с разрешением 1360 x 440 пикселей, что открывает ' +
        'принципиально новые возможности для рекламодателей. На данной конструкции впервые применено решение, позволяющее ' +
        'в одном цикле воспроизводить как разные ролики на сторонах А и Б, так и один общий ролик на всей поверхности ' +
        'в режиме 360 градусов. Шаг установки диодов по высоте и ширине экрана равен 6,1 мм, а угол обзора по вертикали ' +
        'и горизонтали составляет до 110 градусов.</p>' +
        '<h2>Данная конструкция не имеет аналогов в России</h2> ' +
        '<p>Идея создания принадлежит специалистам компании Russ Outdoor, которые подготовили техническое задание.' +
        'Разработчиком и изготовителем экранной части в соответствии с техническим заданием и под контролем ' +
        'специалистов Russ Outdoor выступила компания «Ната - Инфо».</p>',
      video_link:
        "https://youtu.be/QcpZFRtKMok",
    },
    product: {
      title: "Digital ситиборд с трансляцией в режиме 360<sup>o</sup>",
      image: "http://new.russoutdoor.ru/upload/iblock/18c/2.jpg",
      preview_text: 'Функциональная уличная мебель с рекламными поверхностями 1.2х1.8 — павильоны ожидания, остановочные площадки, отдельно стоящие конструкции.',
      text: '<ul>' +
        '       <li><img src="/images/features/sign-1.png" alt=""><span>Единственный допустимый рекламный формат в центральной части Москвы</span></li>\n' +
        '       <li><img src="/images/features/sign-inner.png" alt=""><span>Внутренняя подсветка рекламного поля</span></li>\n' +
        '       <li><img src="/images/features/sign-peoples.png" alt=""><span>Охват пешеходных и транспортных потоков</span></li>\n' +
        '     </ul>',
      video_link: "https://youtu.be/QcpZFRtKMok",
      model_3d: '/images/_tmp/dss_15x5.jpg',
      slides: [
        '/images/_tmp/2.jpg', '/images/_tmp/3.jpg',
      ],
      related: [
        { id: 1, title: 'Digital Билборд', image: "/images/_tmp/project.jpg", }
      ],
    },
  },
});

export const actions = {
  loadTitle({ commit, dispatch, state }, sID) {
    console.log('load STATIC version of content sId = ' + sID);
  },
  loadEntities({ commit, dispatch, state }, sID) {
    console.log('load STATIC version of items sId = ' + sID);
  },
  loadSingle({ commit, dispatch, state }, { sID, ID }) {
    console.log('load STATIC version of single sId = ' + sID + ', id = ' + ID);
  },
  sendFeedback({ commit, dispatch, state }, { name, phone }) {
    console.log('send STATIC version of feedback, name: ' + name + ', phone: ' + phone);
    return new Promise(async (resolve, reject) => {
      resolve({ data: { success: true } });
    });
  },
};



// export const state = () => ({
//   titles: {
//     news: {
//       loaded: true,
//       title: 'Новости',
//       text: 'Описание раздела новостей.',
//       image: '',
//     },
//     cases: {
//       loaded: true,
//       title: 'Мы предлагаем креативные решения',
//       text: 'Какие бы нестандартные задачи ни стояли, Russ Outdoor предложит индивидуальный подход и по-настоящему эффективное решение.',
//       image: 'images/index/cases-img.svg',
//     },
//     world: {
//       loaded: true,
//       title: 'Мы опираемся на&nbsp;мировой опыт',
//       text: 'Стратегическим партнером Russ Outdoor является JCDecaux - признанный мировой лидер наружной рекламы. Доступ к экспертизе партнеров позволяет предоставлять продукты и сервис европейского уровня, определяя лидирующее положение Russ Outdoor в отрасли.',
//       image: 'images/index/world-img.svg',
//     },
//     expert: {
//       loaded: true,
//       title: 'Мы — эксперты визуальных коммуникаций',
//       text: 'Russ Outdoor активно внедряет в свой бизнес современные технологи и уже сегодня предоставляет рекламодателям эксклюзивные возможности размещения с использованием real-time таргетинга.',
//       image: '',
//     },
//   },
//   /* List of elements */
//   entities: {
//     expert: {
//       loaded: false,
//       items: [
//         {
//           id: "1549",
//           title: "Этот элемент - для текстов в раздел &quot;Мы — эксперты...&quot;",
//           image: "http://new.russoutdoor.ru/i/pic.jpg",
//           link: "http://new.russoutdoor.ru/expert/?id=1549&sid=155",
//           text: "Конструкции компании представлены в 38-ми российских городах. Инвентарная линейка оператора включает все основные форматы наружной рекламы, в том числе высокотехнологичные digital экраны, по техническим характеристикам не имеющие аналогов в России.",
//         },
//       ],
//     },
//     cases: {
//       loaded: true,
//       items: [
//         {
//           id: '1',
//           title: 'Очень длинное название проекта, еле умещающееся в три строки',
//           text: 'Краткое описание проекта, цель, задача, решение, охват, количество просмотров, эффект рекламной кампании (или другая информация). ',
//           image: '/images/_tmp/project.jpg',
//           url: '/creative/1',
//         },
//         {
//           id: '2',
//           title: 'Короткое название',
//           text: 'Какие бы нестандартные задачи ни стояли, Russ Outdoor предложит индивидуальный подход и по-настоящему эффективное решение.',
//           image: '/images/_tmp/3.jpg',
//           url: '/creative/2',
//         },
//         {
//           id: '3',
//           title: 'Digital ситиборд с трансляцией в режиме 360o',
//           text: 'Первая в России конструкция, имеющая экраны не только на двух основных сторонах, но и на боковых. Таким образом ситиборд объединяет в себе четыре экрана в один с разрешением 1360 x 440 пикселей, что открывает принципиально новые возможности для рекламодателей.',
//           image: '/images/_tmp/product.jpg',
//           url: '/creative/3',
//         },
//         {
//           id: '4',
//           title: 'Проект с дополненной реальностью на сити-формате для ТНТ',
//           text: 'В мае 2017 г. в Словении была установлена автобусная остановка с дополненной реальностью, демонстрирующая невероятные сцены из жизни дикой природы на фоне урбанистического пейзажа. Кампания под названием «Начало чего-то удивительного» предлагала перенестись в подводное царство и исследовать водный мир в ожидании автобуса.',
//           image: '/images/_tmp/2.jpg',
//           url: '/creative/4',
//         },
//       ],
//     },
//     world: {
//       loaded: true,
//       items: [
//         {
//           id: '1',
//           title: 'Очень длинное название проекта',
//           text: 'Краткое описание проекта, цель, задача, решение, охват, количество просмотров, эффект рекламной кампании (или другая информация). ',
//           image: '/images/_tmp/project.jpg'
//         },
//         {
//           id: '2',
//           title: 'Короткое название 1',
//           text: 'Какие бы нестандартные задачи ни стояли, Russ Outdoor предложит индивидуальный подход и по-настоящему эффективное решение.',
//           image: '/images/_tmp/3.jpg'
//         },
//       ],
//     },
//     news: {
//       loaded: true,
//       items: [
//         {
//           id: '1',
//           date: '24.11.2017',
//           title: 'Новый управляющий директор филиала Russ Outdoor в Санкт-Петербурге',
//           text: 'Орлов будет отвечать за взаимодействие с органами государственной власти, включая продвижение и защиту интересов Компании, а также реализацию стратегических инициатив Компании на территории г. Санкт-Петербурга. Оператору наружной рекламы максимально важно поддерживать контакт с государственными структурами, в том числе, в рамках диалог власти и общества. Орлов будет отвечать за реализацию ...',
//           image: '/images/_tmp/3.jpg',
//           url: '#',
//         },
//         {
//           id: '2',
//           date: '12.11.2017',
//           title: 'Russ Outdoor на Best Cases Conference',
//           text: 'Краткое описание проекта, цель, задача, решение, охват, количество просмотров, эффект рекламной кампании (или другая информация). Краткое описание проекта, цель, задача, решение, охват, количество просмотров, эффект рекламной кампании. Далее инф...',
//           image: '/images/_tmp/3.jpg',
//           url: '#',
//         },
//         {
//           id: '3',
//           date: '01.11.2017',
//           title: 'Новый управляющий директор филиала Russ Outdoor в Санкт-Петербурге',
//           text: 'Орлов будет отвечать за взаимодействие с органами государственной власти, включая продвижение и защиту интересов Компании, а также реализацию стратегических инициатив Компании на территории г. Санкт-Петербурга. Оператору наружной рекламы максимально важно поддерживать контакт с государственными структурами, в том числе, в рамках диалог власти и общества. Орлов будет отвечать за реализацию ...',
//           image: '/images/_tmp/3.jpg',
//           url: '#',
//         },
//         {
//           id: '4',
//           date: '21.10.2017',
//           title: 'Новый управляющий директор филиала Russ Outdoor в Санкт-Петербурге',
//           text: 'Орлов будет отвечать за взаимодействие с органами государственной власти, включая продвижение и защиту интересов Компании, а также реализацию стратегических инициатив Компании на территории г. Санкт-Петербурга. Оператору наружной рекламы максимально важно поддерживать контакт с государственными структурами, в том числе, в рамках диалог власти и общества. Орлов будет отвечать за реализацию ...',
//           image: '/images/_tmp/3.jpg',
//           url: '#',
//         },
//         {
//           id: '5',
//           date: '16.10.2017',
//           title: 'Новый управляющий директор филиала Russ Outdoor в Санкт-Петербурге',
//           text: 'Орлов будет отвечать за взаимодействие с органами государственной власти, включая продвижение и защиту интересов Компании, а также реализацию стратегических инициатив Компании на территории г. Санкт-Петербурга. Оператору наружной рекламы максимально важно поддерживать контакт с государственными структурами, в том числе, в рамках диалог власти и общества. Орлов будет отвечать за реализацию ...',
//           image: '/images/_tmp/3.jpg',
//           url: '#',
//         },
//       ],
//     },
//     products_outd: {
//       loaded: true,
//       items: [
//         {
//           id: "1",
//           title: "Digital Билборд",
//           image: '/images/_tmp/product.jpg',
//           text: "<p>Цифровой экран</p><p>Магистральные конструкции</p>",
//           link: '/products/outdoor/1',
//         },
//         {
//           id: "2",
//           title: "Digital Суперсайт",
//           image: '/images/_tmp/2.jpg',
//           text: "<p>Магистральные конструкции</p>",
//           link: '/products/indoor/1',
//         },
//         {
//           id: "3",
//           title: "Билборд",
//           image: '/images/_tmp/2.jpg',
//           text: "<p>Магистральные конструкции</p>",
//           link: '/products/special/1',
//         },
//         {
//           id: "4",
//           title: "Ситиборд",
//           image: '/images/_tmp/2.jpg',
//           text: "<p>Цифровой экран</p><p>Уличная мебель</p>",
//           link: '/products/outdoor/1',
//         },
//         {
//           id: "5",
//           title: "Суперсайт",
//           image: '/images/_tmp/product.jpg',
//           text: "<p>Магистральные конструкции</p>",
//           link: '/products/city/1',
//         },
//       ],
//     },
//     city: {
//       loaded: true,
//       items: [
//         {
//           id: "1",
//           title: "Digital Билборд",
//           image: '/images/_tmp/product.jpg',
//           text: "<p>Цифровой экран</p><p>Магистральные конструкции</p>",
//           link: '/products/outdoor/1',
//         },
//       ],
//     },
//   },
//   /* Single element */
//   single: {
//     news: {
//       date: '04.11.2017',
//       title: "Russ Outdoor устанавливает остановки по проекту известного архитектора Нормана Фостера в Санкт-Петербурге",
//       image: "http://new.russoutdoor.ru/upload/iblock/18c/2.jpg",
//       text: '<blockquote>Оператор наружной рекламы Russ Outdoor в рамках договора, заключенного по итогам торгов, принял решение ' +
//           'по собственной инициативе обновить 50 остановочных павильонов в городе Санкт-Петербурге, ' +
//           'на Невском и Московском проспектах.</blockquote>' +
//           '<p>Проект остановочного павильона принадлежит всемирно известному британскому архитектору, ' +
//           'лауреату Императорской и Притцкеровской премий, Норману Фостеру. ' +
//           'Аналогичные конструкции успешно функционируют в нескольких мировых столицах с различными ' +
//           'климатическими условиями: Лондоне, Париже, Сеуле, Москве. </p>' +
//           '<figure>' +
//           '  <p><img src="/images/_tmp/2.jpg" alt="Картинка"></p>' +
//           '  <figcaption>' +
//           '   <p>Картинка с текстом оформляется в стандартный HTML5-тег fugure, а подпись - в тег figcaption. Подпись становится слева от картинки. Картинку нужно обернуть в абзац, чтобы у неё появились красивые поля.</p>' +
//           '   <p>Оберните текст в абзац. Шифрование происходит автоматически, что обеспечивает полную анонимность. Для наглядной демонстрации эффективности технологии компания Russ Outdoor пригласила крупнейшие рекламные агентства.</p></figcaption>' +
//           '</figure>' +
//           '<h1>Заголовок первого уровня</h1>' +
//           '<p>Для Санкт-Петербурга архитектурное бюро Фостера разработало проекты реконструкции острова ' +
//           'Новая Голландия и торгового комплекса Апраксин двор.</p>' +
//           '<h2>Заголовок второго уровня, чуть поменьше размером</h2>' +
//           '<p>Остановочные павильоны, изготавливаемые по лицензии в РФ, выполняют основные социальные ' +
//           'функции: защищают от непогоды и предоставляют место для отдыха. ' +
//           'В темное время суток внутреннее и <b>внешнее пространство</b> остановочного павильона освещает ' +
//           'рекламная конструкция. Руководствуясь принципами формирования комфортной городской среды ' +
//           'в преддверии социально значимого мероприятия в городе – <a href="#">Чемпионата Мира по футболу FIFA</a> – ' +
//           'и в рамках городской программы Russ Outdoor дополнительно оснащает остановочные пункты ' +
//           '«умными» функциями.</p>' +
//           '<h3>Третий уровень ещё мельче, но всё же заметен и по-прежнему красив</h3>' +
//           '<p>Павильоны оборудуются такими же табло с информацией о приходе общественного транспорта, ' +
//           'как и в других общественных местах города. Остановки интегрируются с городской сетью Wi-Fi. ' +
//           'Интернет предоставляет оператор связи, привлеченный городом для раздачи сигнала на стадионе ' +
//           'во время проведения ЧМ 2018 и в общественном транспорте.</p>' +
//           '<blockquote>' +
//           ' <header>' +
//           '   <h3>Фамилия Человека в H3</h3>' +
//           '   <p><small>Должность идет в абзаце внутри тега small</small></p>' +
//           ' </header>' +
//           ' <p>Цитата сразу после заголовка в обычном теге абзаца. Единственное дополнение: ' +
//           'заголовок должен идти в стандартном HTML5-теге header</p>' +
//           '</blockquote>' +
//           '<p>Павильоны разработаны таким образом, что в конструкцию может быть интегрировано ' +
//           'дополнительное оборудование для наращивания функционала. ' +
//           'Масштабирование сделает комплексы максимально комфортными и полезными для горожан. ' +
//           'Мы готовы устанавливать также технологичные дисплеи, однако инфраструктура города ' +
//           'не позволяет круглосуточно транслировать digital-формат. </p>' +
//           '<p>Будем дальше обсуждать с городскими властями увеличение количества функциональных ' +
//           'возможностей остановочных пунктов, например, в случае круглосуточной подачи ' +
//           'электроэнергии, – комментирует проект Жан-Эммануэль де Витт, управляющий ' +
//           'директор Russ Outdoor. – Мы гордимся тем, что именно нам выпала возможность ' +
//           'украсить город в преддверии такого масштабного события, как Чемпионат Мира ' +
//           'по футболу FIFA 2018. </p>' +
//           '<h4>Заголовок четвертого уровня выделяет значимый текст, который можно использовать для аннотации к статье, краткого анонса, выделения общей мысли, например, Russ Outdoor – крупнейший оператор наружной рекламы и уличной мебели \n' +
//           'в России. Центральный офис находится в Москве, компания имеет разветвленную федеральную сеть филиалов. С 1995 года оператор, реализуя полный цикл создания и поддержки продукции, предлагает заказчикам комплексные решения для эффективных рекламных кампаний.</h4>' +
//           '<p>Сейчас отличное время, чтобы начать этот проект и ' +
//           'продемонстрировать гостям и жителям, что Санкт-Петербург – действительно ' +
//           'культурная столица с комфортными условиями проживания».</p>' +
//           '<ol>' +
//           '<li>Нумерованные списки сразу становятся вот такими красивыми.</li>' +
//           '<li>Сеть цифровых и статичных щитов классического формата 3*6 на оживленных магистралях и улицах Москвы, ' +
//           'Санкт-Петербурга и регионов.</li>' +
//           '<li>Сеть сити-форматов и уличной мебели (остановки, пиллары, указатели), охватывающая центральную часть города.</li>' +
//           '<li>Indoor: реклама в торговых центрах и магазинах.</li>' +
//           '<li>Эксклюзивные рекламные поверхности: крышные конструкции, брандмауэры, медиафасады, формат «Нестандарт».</li>' +
//           '<li>Рекламные конструкции в аэропорту Пулково: крупноформатные рекламоносители, цифровые видеостены, ' +
//           'стойки для брендирования, сети экранов большого формата, нестандартные поверхности для креативного использования.</li>' +
//           '</ol>' +
//           '<div class="columns"><p>Чтобы сделать блок многоколоночным (двух-колоночным), достаточно создать блок div, section, ' +
//           'или любой другой, и добавить ему класс columns. На маленьких экранах блок становится одноколоночным. Могу привязать к любому другому блоку или любому другому классу. Такой блок будет иметь две колонки.</p> ' +
//           '<p>Первые результаты теста демонстрируют высокую эффективность технологии Synaps для демонстрации сообщений для целевой аудитории в реальном времени. ' +
//           'Распознавание автомобилей происходит на расстоянии до 250 м от конструкции, вне зависимости от того, в каком ряду и в какое время суток они двигаются. ' +
//           'С 1 ноября технология Synaps доступна на 12-ти цифровых суперсайтах Russ Outdoor и уже сейчас рекламные агентства и рекламодатели могут получить полный доступ ' +
//           'к этой уникальной пользовательской платформе.</p>' +
//           '<p>В тексте также может быть картинка. И не только в многоколоночном. Просто вставляйте картинку как стандартный img, можно обернуть в абзац, это не принципиально. Но две кратинки подряд лучше обернуть в абзацы, чтоб не слиплось.</p>' +
//           '<p><img src="/images/_tmp/3.jpg" alt="Картинка"></p>' +
//           '<p>А это текст после картинки. Видите, как он красиво следует после неё? Ничего не прилипает, потому что текст завернут в красивые абзацы p, а не br.</p>' +
//           '</div>' +
//           '<p>«Результат тестовой кампании технологии Synaps приятно удивил. Одно дело - обсуждать вопрос в теории, ' +
//           'предлагать и выслушивать аргументы за и против, высказывать сомнения. ' +
//           'Другое дело - поехать и убедиться, что технология работает и работает, как надо. ' +
//           'Я думал меня уже нельзя ничем удивить».</p>' +
//           '<blockquote class="pictured">' +
//           ' <figure>' +
//           '  <p><img src="/images/_tmp/2.jpg" alt="Картинка"></p>' +
//           '  <figcaption>' +
//           '     <header>' +
//           '       <h3>Фамилия Человека в H3</h3>' +
//           '       <p><small>Должность идет в абзаце внутри тега small</small></p>' +
//           '     </header>' +
//           '     <p>Так как это цитата с картинкой, она состоит из блока цитаты blockquote (с классом pictured) и внутри него блока figure, аналогичного выше. Внутреннее устройство аналогично обычной цитате с авторством.</p>' +
//           '   </figcaption>' +
//           ' </figure>' +
//           '</blockquote>'
//       ,
//       video_file: "http://new.russoutdoor.ru/upload/iblock/17b/c-hr.mp4",
//       video_link: "https://youtu.be/QcpZFRtKMok",
//       slides: [
//         {
//           id: '1',
//           image: '/images/_tmp/project.jpg'
//         },
//         {
//           id: '2',
//           image: '/images/_tmp/3.jpg'
//         },
//       ],
//     },
//     cases: {
//       title: "Digital ситиборд с трансляцией в режиме 360o",
//       image: "http://new.russoutdoor.ru/upload/iblock/18c/2.jpg",
//       text: '<p>Первая в России конструкция, имеющая экраны не только на двух основных сторонах, но и на боковых. ' +
//           'Таким образом ситиборд объединяет в себе четыре экрана в один с разрешением 1360 x 440 пикселей, что открывает ' +
//           'принципиально новые возможности для рекламодателей. На данной конструкции впервые применено решение, позволяющее ' +
//           'в одном цикле воспроизводить как разные ролики на сторонах А и Б, так и один общий ролик на всей поверхности ' +
//           'в режиме 360 градусов. Шаг установки диодов по высоте и ширине экрана равен 6,1 мм, а угол обзора по вертикали ' +
//           'и горизонтали составляет до 110 градусов.</p>' +
//           '<h2>Данная конструкция не имеет аналогов в России</h2> ' +
//           '<p>Идея создания принадлежит специалистам компании Russ Outdoor, которые подготовили техническое задание.' +
//           'Разработчиком и изготовителем экранной части в соответствии с техническим заданием и под контролем ' +
//           'специалистов Russ Outdoor выступила компания «Ната - Инфо».</p>',
//       video_link:
//           "https://youtu.be/QcpZFRtKMok",
//     },
//     world: {
//       title: "Digital ситиборд с трансляцией в режиме 360o",
//       image: "http://new.russoutdoor.ru/upload/iblock/18c/2.jpg",
//       text: '<p>Первая в России конструкция, имеющая экраны не только на двух основных сторонах, но и на боковых. ' +
//           'Таким образом ситиборд объединяет в себе четыре экрана в один с разрешением 1360 x 440 пикселей, что открывает ' +
//           'принципиально новые возможности для рекламодателей. На данной конструкции впервые применено решение, позволяющее ' +
//           'в одном цикле воспроизводить как разные ролики на сторонах А и Б, так и один общий ролик на всей поверхности ' +
//           'в режиме 360 градусов. Шаг установки диодов по высоте и ширине экрана равен 6,1 мм, а угол обзора по вертикали ' +
//           'и горизонтали составляет до 110 градусов.</p>' +
//           '<h2>Данная конструкция не имеет аналогов в России</h2> ' +
//           '<p>Идея создания принадлежит специалистам компании Russ Outdoor, которые подготовили техническое задание.' +
//           'Разработчиком и изготовителем экранной части в соответствии с техническим заданием и под контролем ' +
//           'специалистов Russ Outdoor выступила компания «Ната - Инфо».</p>',
//       video_link:
//           "https://youtu.be/QcpZFRtKMok",
//     },
//     product: {
//       title: "Digital ситиборд с трансляцией в режиме 360<sup>o</sup>",
//       image: "http://new.russoutdoor.ru/upload/iblock/18c/2.jpg",
//       preview_text: 'Функциональная уличная мебель с рекламными поверхностями 1.2х1.8 — павильоны ожидания, остановочные площадки, отдельно стоящие конструкции.',
//       text: '<ul class="ul__icons">' +
//           '       <li class="">Крупный формат уличной мебели</li>\n' +
//           '       <li class="">Расположение в центральных частях города</li>\n' +
//           '       <li class="">Отсутствие “слепых” зон</li>\n' +
//           '       <li class="">Охват пешеходных и транспортных потоков</li>\n' +
//           '       <li class="">Внутренняя подсветка рекламного поля</li>\n' +
//           '     </ul>',
//       video_link: "https://youtu.be/QcpZFRtKMok",
//       model_3d: '/images/_tmp/pilon.jpg', //'/images/_tmp/dss_15x5.jpg',
//       coords: { lat: 55.709504, lng: 37.351428 },
//       slides: [
//         '/images/_tmp/2.jpg', '/images/_tmp/3.jpg',
//       ],
//       related: [
//         { id: 1, title: 'Digital Билборд', image: "/images/_tmp/project.jpg", },
//         { id: 2, title: 'Digital Билборд', image: "/images/_tmp/project.jpg", },
//         // { id: 3, title: 'Digital Билборд', image: "/images/_tmp/project.jpg", },
//         // { id: 4, title: 'Digital Билборд', image: "/images/_tmp/project.jpg", },
//       ],
//     },
//   },
//
// });



// WEBPACK FOOTER //
// ./store/static/content.js